// Get the button
let backToTop = document.getElementById("backToTop");

backToTop.addEventListener('click', topFunction)
// When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function() {scrollFunction()};

function scrollFunction() {
    if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
        backToTop.classList.remove('d-none');
    } else {
        backToTop.classList.add('d-none');
    }
}

// When the user clicks on the button, scroll to the top of the document
function topFunction() {
    window.scrollTo({top: 0, behavior: 'smooth'});
}